import { Button, Text } from '@applyboard/crystal-ui';

type AuthErrorPageProps = {
  readonly onRetry: () => void;
};

export function AuthErrorPage({ onRetry }: AuthErrorPageProps) {
  return (
    <div
      data-testid="auth-error-page"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        padding: 24,
        minHeight: 320,
        textAlign: 'center',
      }}
    >
      <Text variant="headlineL">Session expired</Text>
      <Text variant="bodyM">Your sign-in session is no longer valid. Please sign in to continue.</Text>
      <Button data-testid="auth-error-retry" onClick={onRetry} intent="primary" emphasis="contained">
        Sign in
      </Button>
    </div>
  );
}
